<template>
  <h1 v-if="!!this.title" class="title">
    {{ this.title }}
  </h1>
  <img v-if="this.url" :src="this.url" class="image" alt="photo" />
</template>

<script>
export default {
  name: "ImageUrl",
  data() {
    return {
      url: '',
      title: '',
    }
  },
  mounted() {
    this.url=this.$route.query.url || ''
    this.title=this.$route.query.title || ''
    this.$router.replace({ query: {} });
  }
}
</script>

<style scoped lang="scss">
.image {
  width: auto;
  height: calc(100vh - 70px);
  min-height: 250px;
}
.title {
  font-size: 25px;
  line-height: 29px;
  margin-bottom: 15px;
  font-weight: 700;
  padding: 0 15px;
}
</style>
